<template>
  <v-dialog v-model="dialogVisible" max-width="500" persistent>
    <v-card>
      <v-card-title>{{ isEdit ? 'Editeaza Profil Limitari' : 'Profil Nou Limitari' }}</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-text-field v-model="form.name" label="Nume Profil *" density="compact" :rules="[v => !!v || 'Obligatoriu']" />
          </v-col>
          <v-col cols="12">
            <v-textarea v-model="form.description" label="Descriere" density="compact" rows="3" auto-grow />
          </v-col>
          <v-col cols="12">
            <ClientSearchFilter
              v-model="form.managed_by_client_id"
              :show-include-subclients="false"
              client-select-label="Client proprietar"
              @hierarchy-loaded="onHierarchyLoaded"
            />
          </v-col>
          <v-col cols="12">
            <v-switch v-model="form.enabled" label="Activ" color="primary" density="compact" hide-details />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="close">Anuleaza</v-btn>
        <v-btn color="primary" variant="flat" @click="save" :loading="saving" :disabled="!form.name">{{ isEdit ? 'Salveaza' : 'Creeaza' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {createLimitationProfile, updateLimitationProfile} from '@/composables/useTrafficAlertsAPI'
import ClientSearchFilter from '@/components/ClientSearchFilter.vue'

export default {
  name: 'LimitationProfileDialog',
  components: { ClientSearchFilter },
  props: {
    modelValue: Boolean,
    profile: { type: Object, default: null }
  },
  emits: ['update:modelValue', 'saved'],
  data() {
    return {
      saving: false,
      form: this.getEmptyForm()
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) }
    },
    isEdit() { return !!this.profile?.id }
  },
  watch: {
    modelValue(v) {
      if (v) {
        if (this.profile?.id) {
          this.form = { ...this.profile }
        } else {
          this.form = this.getEmptyForm()
        }
      }
    }
  },
  methods: {
    getEmptyForm() {
      return { name: '', description: '', enabled: true, managed_by_client_id: null }
    },
    onHierarchyLoaded({ currentClientId }) {
      if (!this.form.managed_by_client_id && currentClientId) {
        this.form.managed_by_client_id = currentClientId
      }
    },
    close() {
      this.dialogVisible = false
    },
    async save() {
      this.saving = true
      const token = this.$store.state.token
      let result
      if (this.isEdit) {
        result = await updateLimitationProfile(token, this.form)
      } else {
        result = await createLimitationProfile(token, this.form)
      }
      this.saving = false
      if (!result.error) {
        this.$emit('saved', result.profile)
        this.close()
      } else {
        alert(result.message)
      }
    }
  }
}
</script>
